<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                @save="save"
                @print='print'
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="delSoRelationRows" :disabled="!btn.delSoRelationRows">{{$t('getapi[7115]')}}</el-button>
        </div>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        :data="dataSet"
                        :loading="loading"
                        queryData="ProSOStuffCollectionViewInfo"
                        :filter_thousandth="['assist_coll_qty','gongshi']"
                        :filter_date="['coll_time']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @selection-change="handleSelectionChange"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="coll_sign" :label="$t('getapi[4642]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="coll_time" :label="$t('getapi[4676]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="coll_person" :label="$t('getapi[4677]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="rate" :label="$t('getapi[4678]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="assist_coll_qty" :label="$t('getapi[4679]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="gongshi" :label="$t('getapi[7116]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="aps_code" :label="$t('getapi[6397]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="r_code" :label="$t('getapi[6398]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div style="width:1170px;min-width:1170px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4642]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.coll_sign" :readonly="addoredit != 1" :class="{'readO':addoredit != 1}"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[13457]') }} </td>
                                <td style="width:80px;min-width:80px">       
                                    <el-checkbox v-model="dataDetail.Head.single_measure" :disabled="addoredit != 1"  :true-label=1 :false-label=0></el-checkbox>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4168]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <routejump :urlNo="41">
                                    <el-input  type="text" v-model="dataDetail.Head.so_code"
                                               readonly
                                               class="mcolor"
                                               size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectsocode()"></i>
                                    </el-input>
                                    </routejump>
                                   <!-- <el-input type="text" size="mini" v-model="dataDetail.Head.so_code" v-show="addoredit != 1" :disabled="true"></el-input>-->
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4290]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.relation_sr_code" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4209]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.schedule_no" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4677]') }}</td>
                                <td style="width:100px;min-width:100px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.coll_person" :readonly="true" class="readO"></el-input>
                                </td>
                                
                            </tr>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[112]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_code" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[149]') }}</td>
                                <td style="width:80px;min-width:80px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.part_version" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4291]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.start_working_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3437]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.item_code" :readonly="true" class="readO"></el-input>
                                </td>
                                
                                <!-- <td>%</td> -->
                                <td style="width:60px;min-width:60px">{{ $t('getapi[6398]') }}</td>
                                <td style="width:180px;min-width:180px"><el-input type="text" size="mini" v-model="dataDetail.Head.r_code" :readonly="true" class="readO"></el-input></td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4680]') }}</td>
                                <td style="width:100px;min-width:100px">
                                    <el-input size="mini" style="width:100px;min-width:100px" v-model="dataDetail.Head.rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>%
                                </td>
                            </tr>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4215]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.plan_finish_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4516]') }}</td>
                                <td style="width:80px;min-width:80px">
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.plan_finish_qty" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4489]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.so_status)"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4676]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.coll_time" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                
                                <!-- <td></td> -->
                                <!-- <td style="width:10px;min-width:10px"></td> -->
                                <td style="width:60px;min-width:60px">{{ $t('getapi[6397]') }}</td>
                                <td style="width:180px;min-width:180px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.aps_code" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[578]') }}</td>
                                <td style="width:100px;min-width:100px">
                                    <el-input type="number" style="width:100px;min-width:100px" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.gongshi"></el-input>{{ $t('getapi[6399]') }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style="width:100%;display:flex;">
                        <div style="width:35%">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="selectsodetail" :disabled="dataDetail.MergeLists.length < 1">新增
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDelSo">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.SoLists"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    :height="tableHeight  - 110"
                                    @selection-change="handleSelectionChangeSo"
                                    :row-class-name="tableRowClassNameSo"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:0px"
                                    ref="singleTable1"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_finish_date" :label="$t('getapi[4687]')"></el-table-column>
                                <el-table-column prop="so_statusname" :label="$t('getapi[552]')">
                                    <template scope="scope">
                                        <span>{{ scope.row.so_statusname | lanchange}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <span v-if="dataDetail.SoLists.length != 0">{{$t('getapi[201]')}}{{dataDetail.SoLists.length}}{{$t('getapi[6771]')}}</span>
                        </div>
                        <div style="width:64%;margin-left: 1%">
                            <el-button type="primary" size="mini" @click="batchDelMerge">{{
                                $t('getapi[1522]') }}
                            </el-button>
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.MergeLists"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    :height="tableHeight - 160"
                                    @selection-change="handleSelectionChangeMerge"
                                    :row-class-name="tableRowClassNameMerge"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:0px"
                                    ref="singleTable2"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column prop="assist_coll_qty" :label="$t('getapi[4692]')" align="right">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.assist_coll_qty"  :disabled="dataDetail.Head.single_measure==1"  type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="changeQty(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="coll_qty" :label="$t('getapi[4693]')" align="right">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.coll_qty"  :disabled="dataDetail.Head.single_measure==0"  type="number" autocomplete="off" title="" ></el-input>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column show-overflow-tooltip prop="coll_qty" :label="$t('getapi[4693]')" align="right"></el-table-column> -->
                                <el-table-column show-overflow-tooltip prop="assist_issue_qty" :label="$t('getapi[4694]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="issue_qty" :label="$t('getapi[4695]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            </el-table>
                            <table>
                                <tr>
                                    <td style="color:blue">{{$t('getapi[2475]')}}</td>
                                    <td style="color:blue">{{$t('getapi[6400]')}}</td>
                                    <td><span v-if="dataDetail.MergeLists.length != 0">{{$t('getapi[201]')}}{{dataDetail.MergeLists.length}}{{$t('getapi[6771]')}}</span></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td style="color:blue">{{$t('getapi[6401]')}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td style="color:blue">{{$t('getapi[6402]')}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSOStuffCollectionViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4014]')" queryData="ProSOStuffCollectionViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!--发料单号红字弹窗-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SoRelation/GetSoCodePartPopupList'" @callback="getsocode" ref="socode"></selector>
        <!--发料单号红字弹窗-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SoRelation/GetSoCodePopupList'" @callback="getsodetail" ref="sodetail"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name:'2_sorelationview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_sorelationview'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData:[],
                selectDataSo: [],
                selectDataMerge: [],
                dataDetail:{
                    Head:{
                        coll_sign: '',
                        so_code: '',
                        relation_sr_code: '',
                        schedule_no: '',
                        part_code: '',
                        part_version: '',
                        start_working_date: '',
                        item_code: '',
                        plan_finish_date: '',
                        plan_finish_qty: '',
                        so_status: 0,
                        coll_person: '',
                        coll_time: '',
                        rate: '',
                        gongshi: '',
                        aps_code: '',
                        r_code: '',
                        isadd: 1
                    },
                    SoLists:[],
                    MergeLists:[],
                },
                oldDataDetail: '',
                oldrow: '',
                iscontinuedblclick: true,
                code:'',
                btn: {
                    delSoRelationRows: false
                },
                addoredit: 1,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        watch: {
            /*dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.SoLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            },
            'dataDetail.MergeLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(1)
                })
            }*/
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_sorelationview', that)
            that.userData = sessionStorage.getItem('userData');
            that.$limits.dragControllerDiv();
            that.authority();
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSOStuffCollectionViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4014]"),this.$t("getapi[6588]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (!this.$limits.menuvisible("plv2", 294, 1)) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                } else {
                    if (that.$limits.authority('plv2', 294, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                    }
                    if (that.$limits.authority('plv2', 294, 1) == 2) {
                        if (that.$limits.authority('plv3', 290,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 290,1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                        }
                        if (that.$limits.authority('plv3', 290, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.delSoRelationRows = false
                if(that.selectData.length>0){
                    if(that.$limits.authority('plv3', 291,1) > 0){
                        that.btn.delSoRelationRows = true
                    }
                }
            },
            tableRowClassNameSo({row, rowIndex}) {
                row.index = rowIndex
            },
            tableRowClassNameMerge({row, rowIndex}) {
                row.index = rowIndex
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_sorelationview',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOStuffCollectionViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/SoRelation/SoRelationList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            print(){
                let that = this;
                if(that.selectData.length==0)return;
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.loading = true;
                let parm = [];
                for(let i=0;i<that.selectData.length;i++){
                    let uobj={
                        so_code:that.selectData[i].coll_sign
                    }
                    parm.push(uobj);
                }
                that.$http.urlpost('/Print/PGDPrint', parm, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                if (res.Success == 1) {
                let hrefurl = res.Key;
                window.open(hrefurl);
                } 
                that.loading = false;
                });

            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/SoRelation/SoRelationToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSOStuffCollectionViewInfo",
                    fromname: that.$t('getapi[4014]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChangeSo(val){
                let that = this;
                that.selectDataSo = val;
            },
            handleSelectionChangeMerge(val){
                let that = this;
                that.selectDataMerge = val;
            },
            //删除排产关联号
            delSoRelationRows(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        coll_sign: that.selectData[i].coll_sign
                    }]
                }
                let parm = {
                    List: arr
                }
                that.$http.urlpost('/Pro/SoRelation/DelSoRelationRows', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.SoLists.length;i++){
                    delete datacopy.SoLists[i]['index']
                }
                for(let i=0;i<datacopy.MergeLists.length;i++){
                    delete datacopy.MergeLists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 1
                that.code = {
                    coll_sign: '',
                    so_code: '',
                    rate: ''
                }
                that.dataDetail.Head = {
                    coll_sign: '',
                    so_code: '',
                    relation_sr_code: '',
                    schedule_no: '',
                    part_code: '',
                    part_version: '',
                    start_working_date: '',
                    item_code: '',
                    plan_finish_date: '',
                    plan_finish_qty: '',
                    so_status: 0,
                    coll_person: '',
                    coll_time: '',
                    rate: '',
                    gongshi: '',
                    aps_code: '',
                    r_code: '',
                    isadd: 1,
                    single_measure:0
                }
                that.dataDetail.SoLists = []
                that.dataDetail.MergeLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            editInfo(row){
                let that = this
                if(that.code.coll_sign == row.coll_sign){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.SoLists.length;i++){
                        delete datacopy.SoLists[i]['index']
                    }
                    for(let i=0;i<datacopy.MergeLists.length;i++){
                        delete datacopy.MergeLists[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = {
                                    coll_sign: row.coll_sign,
                                    so_code: '',
                                    rate: row.rate
                                }
                                that.getDetail(that.code)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = {
                            coll_sign: row.coll_sign,
                            so_code: '',
                            rate: row.rate
                        }
                        that.getDetail(that.code)
                    }
                }, 100);
            },
            getDetail(parm){
                let that = this
                that.addoredit = 2
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SoRelation/GetSoRelationBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        for(let i =0;i<that.dataDetail.SoLists.length;i++){
                            that.dataDetail.SoLists[i].isadd = 0
                        }                        
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority(2);
                        that.btnauthority()
                    }
                    loadingInstance.close()
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[1488]')//'下达'
                } else if(val == 2){
                    return that.$t('getapi[4222]')//'开工'
                } else if(val == 3){
                    return that.$t('getapi[441]')//'关闭'
                } else if(val == 4){
                    return that.$t('getapi[6]')//'取消'
                } else {
                    return ''
                }
            },
            reExpStatus(val){
                let that = this
                if(val == '生成'){
                    return 0
                } else if(val == '下达'){
                    return 1
                } else if(val == '开工'){
                    return 2
                } else if(val == '关闭'){
                    return 3
                } else if(val == '取消'){
                    return 4
                } else {
                    return ''
                }
            },
            //单据删除
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            coll_sign: that.dataDetail.Head.coll_sign,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pro/SoRelation/DelSoRelation', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelSo() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            coll_sign: that.dataDetail.Head.coll_sign,
                            List: []
                        };
                        for (let i = that.selectDataSo.length - 1; i >= 0; i--) {
                            that.dataDetail.SoLists.splice(that.selectDataSo[i].index, 1);
                            if(that.selectDataSo[i].isadd != 1){
                                let datatmp = {
                                    so_code: that.selectDataSo[i].so_code
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if(parm.List.length>0){
                            that.$http.urlpost('/Pro/SoRelation/DelSoListData', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.code);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelMerge() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(that.addoredit == 1){
                            for (let i = that.selectDataMerge.length-1; i >= 0; i--) {
                                that.dataDetail.MergeLists.splice(that.selectDataMerge[i].index, 1);
                            }
                        } else {
                            let arr = []
                            for (let i = 0;i< that.selectDataMerge.length; i++) {
                                arr = [...arr,{
                                    part_id: that.selectDataMerge[i].part_id
                                }]
                            }
                            let parm = {
                                coll_sign: that.dataDetail.Head.coll_sign,
                                List: arr
                            };
                            that.$http.urlpost('/Pro/SoRelation/DelMergeListData', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.code = {
                                        coll_sign: that.dataDetail.Head.coll_sign,
                                        so_code: that.dataDetail.Head.so_code,
                                        rate: that.dataDetail.Head.rate
                                    }
                                    that.getDetail(that.code);
                                }
                                else if (res.Success == 2) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.confirmAdd();
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectsocode(){
                let that = this;                
                let param = {
                    single_measure:that.dataDetail.Head.single_measure
                };
                that.$refs.socode.clearInput(true,param);
            },
            getsocode(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.so_code = data.so_code
                that.dataDetail.Head.item_code = data.item_code
                that.dataDetail.Head.part_code = data.part_code
                that.dataDetail.Head.part_version = data.part_version
                that.dataDetail.Head.plan_finish_date = data.plan_finish_date
                that.dataDetail.Head.plan_finish_qty = data.plan_finish_qty
                that.dataDetail.Head.relation_sr_code = data.relation_sr_code
                that.dataDetail.Head.schedule_no = data.schedule_no
                that.dataDetail.Head.start_working_date = data.start_working_date
                that.dataDetail.Head.so_status = that.reExpStatus(data['状态'])
                that.getSoPartList(that.dataDetail.Head.so_code)
                that.btnauthority()
            },
            selectsodetail(){
                let that = this
                let arr = []
                for(let i =0;i<that.dataDetail.MergeLists.length;i++){
                    arr = [...arr,{
                        part_id: that.dataDetail.MergeLists[i].part_id
                    }]
                }
                let param = {
                    "coll_sign": that.dataDetail.Head.coll_sign,
                    "so_code": that.dataDetail.Head.so_code,
                    "list":arr
                }
                that.$refs.sodetail.clearInput(true,param);
            },
            getsodetail(data){
                let that = this
                console.log(data)
                that.dataDetail.SoLists = [...that.dataDetail.SoLists,{
                    "so_code": data.so_code,
                    "item_code": data.Item_Code,
                    "plan_finish_date": data.Plan_Finish_date,
                    "so_status": data.so_status,
                    "so_statusname": data.so_statusname,
                    isadd: 1
                }]
            },
            getSoPartList(code){
                let that = this
                let parm = {
                    so_code: code,
                    single_measure:that.dataDetail.Head.single_measure
                }
                that.$http.urlpost('/Pro/SoRelation/GetSoPartList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.MergeLists = res.DataContent.MergeLists
                    }
                });
            },
            // 集成量修改
            changeQty(row){
                let that = this
                let index = row.$index
                if(!that.$limits.fnIsEmpty(that.dataDetail.MergeLists[index].part_code)){
                    let tr = 0
                    tr = parseFloat(that.dataDetail.MergeLists[index].assist_coll_qty)
                    let hrate = 1
                    hrate = parseFloat(that.dataDetail.MergeLists[index].master_assist_rate)
                    that.dataDetail.MergeLists[index].coll_qty = tr * hrate
                }
            },
            save(){
                let that = this;
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pro/SoRelation/SaveSoRelation', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = {
                            coll_sign: res.UniqueNum,
                            so_code: that.dataDetail.Head.so_code,
                            rate: that.dataDetail.Head.rate
                        }
                        that.getDetail(that.code);
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 290,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.SoLists.length;i++){
                    delete datacopy.SoLists[i]['index']
                }
                for(let i=0;i<datacopy.MergeLists.length;i++){
                    delete datacopy.MergeLists[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
